<template>
    <div>
      <div class="btn-contain">
        
        <div class="btn-particles "></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ShakingParticles',
};
</script>

<style>
.shape {
position: absolute;
width: 50px;
height: 50px;
transform: scale(0.8);
}
.cir {
position: absolute;
border-radius: 50%;
z-index: 5;
}



.btn-particles {
width: 100px;
height: 100px;
position: absolute;
/* border-radius: 50%; */
margin: 0 120px;
color: #eee;
font-family: monospace;
z-index: 5;
}
.btn:active {
transform: scale(0.9) translate(-55%, -55%);
}
</style>







